import { render, staticRenderFns } from "./clientList.vue?vue&type=template&id=205b7030&scoped=true&"
import script from "./clientList.vue?vue&type=script&lang=ts&"
export * from "./clientList.vue?vue&type=script&lang=ts&"
import style0 from "./clientList.vue?vue&type=style&index=0&id=205b7030&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b7030",
  null
  
)

export default component.exports